<template>
  <head>
    <meta charset="utf-8" />
    <title>Hotline Transporters Sacco | All invoices</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Rental management system by Nouveta LTD" name="description" />
    <meta content="Kelvin Njuguna" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <!-- droping file -->
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css" />

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Bootstrap select styling -->
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
  </head>

  <body @contextmenu.prevent data-sidebar="dark">

  <!-- Begin page -->
  <div id="layout-wrapper">

    <NavigationBar/>

    <!-- Start right Content here -->
    <div class="content-minimize">

      <div class="page-content">
        <div class="container-fluid">

          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Housing and Stall rentals</h4>

                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="index.html">Dashboards</a></li>
                    <li class="breadcrumb-item"><a href="housing-quick-stat.html">Housing</a></li>
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Rentals Register</a></li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <!-- end page title -->

          <!-- tool bar -->
          <ToolBarHousing/>
          <!-- end page title -->

          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white w-100 border-bottom d-flex justify-content-between align-items-center">
                  <h4 class="card-title text-uppercase">
                    Rents Register
                  </h4>
                  <div class="d-flex">
                    <!-- Reconcile All Button -->
                    <button
                        @click="showReconcileConfirmation()"
                        type="button"
                        class="btn btn-warning text-uppercase dropdown-toggle option-selector me-3"
                        :disabled="isReconciling">
                      <i class="bx bx-refresh font-size-16"></i>
                      <span class="pl-1 d-md-inline">Reconcile All Units</span>
                    </button>

                    <a @click="gotTo('housing-new')" href="javascript: void(0);" type="button" class="btn btn-success text-uppercase dropdown-toggle option-selector me-3">
                      <i class="bx bx-plus font-size-16"></i> <span class="pl-1 d-md-inline">Add Property</span>
                    </a>

                    <button data-bs-toggle="modal" data-bs-target=".add-block-modal" type="button" class="btn btn-secondary text-uppercase dropdown-toggle option-selector me-3">
                      <i class="bx bx-list-plus font-size-16"></i> <span class="pl-1 d-md-inline">Add Unit Category</span>
                    </button>
                  </div>
                </div>

                <div class="card-body">
                  <div class="row">
                    <div class="col-xl-3 col-sm-6">
                      <div class="card shadow-none border">
                        <div class="card-body p-3">
                          <div class="">
                            <div class="avatar-xs me-3 mb-3">
                              <div class="avatar-title bg-transparent rounded">
                                <i class="mdi mdi-cash-remove font-size-24 text-danger"></i>
                              </div>
                            </div>
                            <div class="d-flex">
                              <div class="overflow-hidden me-auto">
                                <h5 class="font-size-14 text-truncate mb-1"><a href="javascript: void(0);" class="text-body">Outstanding Arrears</a></h5>
                                <p class="text-muted text-truncate mb-0">{{numberFormat(totalArreas)}}</p>
                              </div>
                              <div class="align-self-end ms-2">
                                <p class="text-muted mb-0">{{numberFormat(totalUnit)}} UNITS</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-xl-3 col-sm-6">
                      <div class="card shadow-none border">
                        <div class="card-body p-3">
                          <div class="">
                            <div class="avatar-xs me-3 mb-3">
                              <div class="avatar-title bg-transparent rounded">
                                <i class="mdi mdi-account-cash-outline font-size-24 text-success"></i>
                              </div>
                            </div>
                            <div class="d-flex">
                              <div class="overflow-hidden me-auto">
                                <h5 class="font-size-14 text-truncate mb-1"><a href="javascript: void(0);" class="text-body">This Month's Collections</a></h5>
                                <p class="text-muted text-truncate mb-0">{{numberFormat(totalReceiptAmount)}}</p>
                              </div>
                              <div class="align-self-end ms-2">
                                <p class="text-muted mb-0">{{numberFormat(totalRecords)}} UNITS</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-xl-3 col-sm-6">
                      <div class="card shadow-none border">
                        <div class="card-body p-3">
                          <div class="">
                            <div class="avatar-xs me-3 mb-3">
                              <div class="avatar-title bg-transparent rounded">
                                <i class="mdi mdi-home-group font-size-24 text-dark"></i>
                              </div>
                            </div>
                            <div class="d-flex">
                              <div class="overflow-hidden me-auto">
                                <h5 class="font-size-14 text-truncate mb-1"><a href="javascript: void(0);" class="text-body">Number Of Units</a></h5>
                                <p class="text-muted text-truncate mb-0">{{numberFormat(totalUnit)}} Units</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-xl-3 col-sm-6">
                      <div class="card shadow-none border">
                        <div class="card-body p-3">
                          <div class="">
                            <div class="avatar-xs me-3 mb-3">
                              <div class="avatar-title bg-transparent rounded">
                                <i class="mdi mdi-home-export-outline font-size-24 text-warning"></i>
                              </div>
                            </div>
                            <div class="d-flex">
                              <div class="overflow-hidden me-auto">
                                <h5 class="font-size-14 text-truncate mb-1"><a href="javascript: void(0);" class="text-body">Vacant Units</a></h5>
                                <p class="text-muted text-truncate mb-0">{{numberFormat(totalVaccant)}} Units</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">
                  <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100" role="toolbar">
                    <div class="flex-grow-1">
                      <div class="search-box mb-0 me-3">
                        <div class="position-relative">
                          <input v-model="search" type="text" class="form-control bg-light border-light rounded" placeholder="Search..." fdprocessedid="husj3l">
                          <i class="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex gap-2">
                      <!-- Download Current Page -->
                      <button
                          @click="downloadCurrentPage()"
                          type="button"
                          class="btn btn-success text-capitalize"
                          :disabled="properties.length === 0 || isDownloading">
                        <i class="bx bxs-download font-size-16"></i>
                        <span class="ms-1">Download Page</span>
                      </button>

                      <!-- Download All Records -->
                      <button
                          @click="downloadAllRecords()"
                          type="button"
                          class="btn btn-primary text-capitalize"
                          :disabled="isDownloadingAll || totalUnit === 0">
                        <span v-if="isDownloadingAll">
                          <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                          Downloading...
                        </span>
                        <span v-else>
                          <i class="bx bxs-cloud-download font-size-16"></i>
                          <span class="ms-1">Download All ({{ numberFormat(totalUnit) }} units)</span>
                        </span>
                      </button>
                    </div>
                  </div>
                </div>

                <div class="card-body">
                  <div class="table-responsive overflow-visible">
                    <table class="table align-middle table-hover contacts-table table-striped" id="">
                      <thead class="table-light">
                      <tr class="table-dark">
                        <th>#</th>
                        <th scope="col">Market/Estate</th>
                        <th>No. Of Rentals</th>
                        <th>Occupied</th>
                        <th>Vacant</th>
                        <th scope="col" class="text-right">Arrears</th>
                        <th></th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr :key="index" :value="item" v-for="(item, index) in properties">
                        <td class="text-capitalize text-nowrap"><strong>{{index+1}}.</strong></td>
                        <td class="text-capitalize text-nowrap">
                          <a @click="gotTo('housing-detail',item.propertyID)" href="javascript: void(0);">{{item.property}}</a>
                        </td>
                        <td class="text-capitalize text-nowrap">{{numberFormat(item.noOfUnits)}}</td>
                        <td class="text-capitalize text-nowrap">{{numberFormat(item.noOfOccupiedUnits)}}</td>
                        <td class="text-capitalize text-nowrap">{{numberFormat(item.noOfEmptyUnits)}}</td>
                        <td class="text-capitalize text-nowrap text-right">{{numberFormat(item.totalArrears)}}</td>
                        <td>
                          <div class="d-flex justify-content-end">
                            <button
                                @click="reconcileProperty(item)"
                                type="button"
                                class="btn btn-outline-warning btn-sm waves-effect waves-light text-nowrap me-2"
                                title="Reconcile this property">
                              <i class="bx bx-refresh"></i>
                            </button>
                            <a @click="gotTo('housing-detail',item.propertyID)" type="button" href="javascript: void(0);" class="btn btn-primary btn-sm waves-effect waves-light text-nowrap me-3">View Details</a>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                      <tfoot class="table-dark">
                      <tr>
                        <th colspan="2">
                          {{numberFormat(properties.length)}}
                        </th>
                        <th>
                          {{numberFormat(totalUnit)}}
                        </th>
                        <th>{{numberFormat(totalOccupied)}}</th>
                        <th>
                          {{numberFormat(totalVaccant)}}
                        </th>
                        <td class="text-nowrap text-right" colspan="">
                          <span class="fw-semibold">{{numberFormat(totalArreas)}}</span>
                        </td>
                        <td></td>
                      </tr>
                      </tfoot>
                    </table>

                    <div v-if="loading" class="card-body px-5 d-flex flex-column justify-items-center align-items-center text-center d-flex justify-content-center">
                      <div class="p-5 py-0 pt-3">
                        <div class="p-5">
                          <div class="spinner-border text-info m-1" role="status">
                            <span class="sr-only text-uppercase">Loading...</span>
                          </div>
                        </div>
                      </div>
                      <h4 class="text-uppercase">Loading Data</h4>
                      <div class="col-sm-12 col-md-8 col-lg-5">
                        <p>We are fetching the data for you. It will be ready soon. Please wait and have fun. Thank you for your interest.</p>
                      </div>
                    </div>

                    <div v-if="properties.length<1 & loading === false" class="card-body d-sm-none d-md-block px-5 d-flex flex-column justify-items-center align-items-center text-center">
                      <div class="p-5 py-0 pt-3">
                        <img :src="'./assets/images/no-results.png'" class="img mb-4" alt="No search results"/>
                      </div>
                      <h4>No Results To Show</h4>
                      <p>Sorry, we could not find any results that match your search or filter criteria. Please try using different keywords or filters.</p>
                    </div>
                  </div>
                </div>

                <div class="card-footer bg-white">
                  <nav aria-label="Page navigation example" class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                      <span class="pr-3 pb-0 mb-0 font-13px">
                        <span>Rows Per Page</span>
                      </span>
                      <select class="form-select w-auto font-13px" v-model="pageSize">
                        <option value="10">10 Rows</option>
                        <option value="25">25 Rows</option>
                        <option value="50">50 Rows</option>
                        <option value="100">100 Rows</option>
                        <option value="150">150 Rows</option>
                        <option value="200">200 Rows</option>
                        <option value="5000">5000 Rows</option>
                        <option value="10000">10000 Rows</option>
                        <option value="100000000000">All Rows</option>
                      </select>
                    </div>

                    <ul class="pagination">
                      <li class="page-item" :class="{ disabled: currentPage === 1 }">
                        <a class="page-link" tabindex="-1" @click="prevPage" :disabled="currentPage === 1">Previous</a>
                      </li>
                      <li v-for="page in pagination(currentPage, totalPages, 3)" :key="page" class="page-item" :class="{ active: currentPage === page }">
                        <span v-if="page === '...'" class="page-link">{{ page }}</span>
                        <a v-else class="page-link" @click="goToPage(page)">{{ page }}</a>
                      </li>
                      <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                        <a class="page-link" @click="nextPage" :disabled="currentPage === totalPages">Next</a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Reconciliation Confirmation Modal -->
      <div class="modal fade" id="reconcileConfirmModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header bg-warning">
              <h5 class="modal-title">
                <i class="bx bx-refresh me-2"></i>Confirm Reconciliation
              </h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="text-center mb-4">
                <i class="bx bx-error-circle text-warning" style="font-size: 4rem;"></i>
              </div>

              <h5 class="text-center mb-3">Are you sure you want to reconcile all units?</h5>

              <div class="alert alert-info">
                <h6 class="alert-heading"><i class="bx bx-info-circle me-1"></i>What this will do:</h6>
                <ul class="mb-0 ps-3">
                  <li>Recalculate arrears and credit balances for all units</li>
                  <li>Fix units with incorrect balances after advance payments</li>
                  <li>Respect migrated PAID entries from the old system</li>
                  <li>Generate a detailed report of all changes</li>
                </ul>
              </div>

              <div class="alert alert-warning">
                <i class="bx bx-time-five me-1"></i>
                <strong>Estimated time:</strong> This process may take several minutes depending on the number of units.
              </div>

              <div class="form-check mb-3">
                <input class="form-check-input" type="checkbox" v-model="reconcileSelectedPropertyOnly" id="reconcileSelectedOnly">
                <label class="form-check-label" for="reconcileSelectedOnly">
                  Reconcile specific property only
                </label>
              </div>

              <div v-if="reconcileSelectedPropertyOnly" class="mb-3">
                <label class="form-label">Select Property</label>
                <select class="form-select" v-model="selectedPropertyForReconcile">
                  <option value="">-- Select Property --</option>
                  <option v-for="prop in properties" :key="prop.propertyID" :value="prop.propertyID">
                    {{ prop.property }} ({{ prop.noOfUnits }} units)
                  </option>
                </select>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-warning" @click="startReconciliation()">
                <i class="bx bx-refresh me-1"></i>Start Reconciliation
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Reconciliation Progress Modal -->
      <div class="modal fade" id="reconcileProgressModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
        <div class="modal-dialog modal-lg modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header bg-warning">
              <h5 class="modal-title">
                <i class="bx bx-refresh me-2 bx-spin"></i>Reconciling Units
              </h5>
            </div>
            <div class="modal-body">
              <!-- Progress Section -->
              <div class="text-center mb-4">
                <div v-if="!reconcilePaused && !reconcileComplete" class="spinner-border text-warning mb-3" style="width: 3rem; height: 3rem;" role="status">
                  <span class="visually-hidden">Processing...</span>
                </div>
                <div v-else-if="reconcileComplete" class="mb-3">
                  <i class="bx bx-check-circle text-success" style="font-size: 3rem;"></i>
                </div>
                <div v-else class="mb-3">
                  <i class="bx bx-pause-circle text-warning" style="font-size: 3rem;"></i>
                </div>

                <h5 v-if="reconcileComplete" class="text-success">Reconciliation Complete!</h5>
                <h5 v-else-if="reconcilePaused" class="text-warning">Reconciliation Paused</h5>
                <h5 v-else>Processing units, please wait...</h5>
              </div>

              <!-- Progress Bar -->
              <div class="progress mb-3" style="height: 30px;">
                <div
                    class="progress-bar progress-bar-striped"
                    :class="{
                      'progress-bar-animated': !reconcilePaused && !reconcileComplete,
                      'bg-warning': !reconcileComplete,
                      'bg-success': reconcileComplete
                    }"
                    role="progressbar"
                    :style="{ width: reconcileProgress.percentage + '%' }">
                  {{ reconcileProgress.percentage }}%
                </div>
              </div>

              <!-- Stats Row -->
              <div class="row text-center mb-4">
                <div class="col-3">
                  <div class="border rounded p-2">
                    <h4 class="mb-0 text-primary">{{ reconcileProgress.processed }}</h4>
                    <small class="text-muted">Processed</small>
                  </div>
                </div>
                <div class="col-3">
                  <div class="border rounded p-2">
                    <h4 class="mb-0 text-success">{{ reconcileProgress.changed }}</h4>
                    <small class="text-muted">Changed</small>
                  </div>
                </div>
                <div class="col-3">
                  <div class="border rounded p-2">
                    <h4 class="mb-0 text-info">{{ reconcileProgress.unchanged }}</h4>
                    <small class="text-muted">Unchanged</small>
                  </div>
                </div>
                <div class="col-3">
                  <div class="border rounded p-2">
                    <h4 class="mb-0 text-danger">{{ reconcileProgress.errors }}</h4>
                    <small class="text-muted">Errors</small>
                  </div>
                </div>
              </div>

              <!-- Time Remaining -->
              <div v-if="!reconcileComplete && reconcileProgress.estimatedTimeRemaining" class="text-center mb-3">
                <p class="mb-1">
                  <i class="bx bx-time-five me-1"></i>
                  <strong>{{ formatTimeRemaining(reconcileProgress.estimatedTimeRemaining) }}</strong> remaining
                </p>
                <small class="text-muted">Processing {{ reconcileProgress.speed }} units/sec</small>
              </div>

              <!-- Current Unit Info -->
              <div v-if="!reconcileComplete && reconcileProgress.currentUnit" class="alert alert-light mb-3">
                <small>
                  <strong>Current:</strong> {{ reconcileProgress.currentUnit.unitNo }} - {{ reconcileProgress.currentUnit.property }}
                </small>
              </div>

              <!-- Summary of Changes (shown during and after) -->
              <div v-if="reconcileResults.length > 0" class="mt-3">
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <h6 class="mb-0">Changes Made ({{ reconcileResults.filter(r => r.changed).length }} units)</h6>
                  <div class="btn-group btn-group-sm">
                    <button
                        class="btn btn-outline-secondary"
                        :class="{ active: showOnlyChanged }"
                        @click="showOnlyChanged = true">
                      Changed Only
                    </button>
                    <button
                        class="btn btn-outline-secondary"
                        :class="{ active: !showOnlyChanged }"
                        @click="showOnlyChanged = false">
                      All
                    </button>
                  </div>
                </div>

                <div class="table-responsive" style="max-height: 250px; overflow-y: auto;">
                  <table class="table table-sm table-striped table-bordered mb-0">
                    <thead class="table-dark sticky-top">
                    <tr>
                      <th>Unit</th>
                      <th>Property</th>
                      <th class="text-end">Old Arrears</th>
                      <th class="text-end">New Arrears</th>
                      <th class="text-end">Old Credit</th>
                      <th class="text-end">New Credit</th>
                      <th class="text-center">Status</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(result, idx) in filteredReconcileResults" :key="idx">
                      <td>{{ result.unitNo }}</td>
                      <td>{{ result.property }}</td>
                      <td class="text-end" :class="{ 'text-danger': result.oldArrears > 0 }">
                        {{ numberFormat(result.oldArrears) }}
                      </td>
                      <td class="text-end" :class="{ 'text-danger': result.newArrears > 0, 'text-success': result.newArrears < result.oldArrears }">
                        {{ numberFormat(result.newArrears) }}
                        <i v-if="result.newArrears < result.oldArrears" class="bx bx-down-arrow-alt text-success"></i>
                        <i v-else-if="result.newArrears > result.oldArrears" class="bx bx-up-arrow-alt text-danger"></i>
                      </td>
                      <td class="text-end" :class="{ 'text-success': result.oldCredit > 0 }">
                        {{ numberFormat(result.oldCredit) }}
                      </td>
                      <td class="text-end" :class="{ 'text-success': result.newCredit > 0 }">
                        {{ numberFormat(result.newCredit) }}
                        <i v-if="result.newCredit > result.oldCredit" class="bx bx-up-arrow-alt text-success"></i>
                      </td>
                      <td class="text-center">
                        <span v-if="result.changed" class="badge bg-success">Changed</span>
                        <span v-else class="badge bg-secondary">No Change</span>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- Error Display -->
              <div v-if="reconcileError" class="alert alert-danger mt-3">
                <i class="bx bx-error-circle me-1"></i>
                <strong>Error:</strong> {{ reconcileError }}
              </div>
            </div>
            <div class="modal-footer">
              <template v-if="!reconcileComplete">
                <button v-if="!reconcilePaused" class="btn btn-warning" @click="pauseReconciliation()">
                  <i class="bx bx-pause me-1"></i>Pause
                </button>
                <button v-else class="btn btn-success" @click="resumeReconciliation()">
                  <i class="bx bx-play me-1"></i>Resume
                </button>
                <button class="btn btn-danger" @click="cancelReconciliation()">
                  <i class="bx bx-x me-1"></i>Cancel
                </button>
              </template>
              <template v-else>
                <button class="btn btn-primary" @click="downloadReconcileReport()">
                  <i class="bx bx-download me-1"></i>Download Report
                </button>
                <button class="btn btn-secondary" @click="closeReconcileModal()">Close</button>
              </template>
            </div>
          </div>
        </div>
      </div>

      <!-- Download Progress Modal (existing) -->
      <div class="modal fade" id="downloadProgressModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header bg-primary text-white">
              <h5 class="modal-title text-white">
                <i class="bx bxs-download me-2"></i>Downloading Housing Records
              </h5>
            </div>
            <div class="modal-body">
              <div class="text-center mb-3">
                <div class="spinner-border text-primary mb-3" style="width: 3rem; height: 3rem;" role="status" v-if="!downloadPaused">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <div v-else class="mb-3">
                  <i class="bx bx-pause-circle text-warning" style="font-size: 3rem;"></i>
                </div>
                <h5 v-if="!downloadPaused">Please wait while we download your records...</h5>
                <h5 v-else class="text-warning">Download Paused</h5>

                <div v-if="downloadProgress.estimatedTimeRemaining && !downloadPaused" class="mt-2">
                  <p class="text-muted mb-1">
                    <i class="bx bx-time-five me-1"></i>
                    <strong>{{ formatTimeRemaining(downloadProgress.estimatedTimeRemaining) }}</strong> remaining
                  </p>
                  <small class="text-muted">
                    Average speed: {{ downloadProgress.averageSpeed }} properties/sec
                  </small>
                </div>

                <p class="text-muted mt-2">{{ downloadPaused ? 'You can resume or cancel the download.' : 'This may take several minutes depending on the amount of data.' }}</p>
              </div>

              <div class="progress mb-3" style="height: 25px;">
                <div
                    class="progress-bar progress-bar-striped"
                    :class="{'progress-bar-animated': !downloadPaused, 'bg-warning': downloadPaused}"
                    role="progressbar"
                    :style="{ width: downloadProgress.percentage + '%' }"
                    :aria-valuenow="downloadProgress.percentage"
                    aria-valuemin="0"
                    aria-valuemax="100">
                  {{ downloadProgress.percentage }}%
                </div>
              </div>

              <div class="d-flex justify-content-between text-muted small mb-3">
                <span>Property {{ downloadProgress.currentProperty }} of {{ downloadProgress.totalProperties }}</span>
                <span>{{ downloadProgress.totalUnitsDownloaded }} units downloaded</span>
              </div>

              <div v-if="downloadProgress.currentPropertyName" class="alert alert-info mb-3">
                <small>
                  <strong>Current:</strong> {{ downloadProgress.currentPropertyName }}
                  <br>
                  <strong>Units:</strong> {{ downloadProgress.currentPropertyUnits }} units
                </small>
              </div>

              <div v-if="downloadError" class="alert alert-danger d-flex align-items-center" role="alert">
                <i class="bx bx-error-circle me-2"></i>
                <div class="flex-grow-1">
                  <strong>Error:</strong> {{ downloadError }}
                  <br>
                  <small>You can retry from where it stopped or cancel the download.</small>
                </div>
              </div>

              <div v-if="downloadRetryCount > 0" class="alert alert-warning d-flex align-items-center mb-3" role="alert">
                <i class="bx bx-info-circle me-2"></i>
                <small>Retry attempt {{ downloadRetryCount }} of 3</small>
              </div>

              <div class="d-flex gap-2 justify-content-center mb-3">
                <button
                    v-if="!downloadPaused && !downloadError"
                    @click="pauseDownload"
                    class="btn btn-warning btn-sm">
                  <i class="bx bx-pause me-1"></i>Pause
                </button>
                <button
                    v-if="downloadPaused || downloadError"
                    @click="resumeDownload"
                    class="btn btn-success btn-sm">
                  <i class="bx bx-play me-1"></i>Resume
                </button>
                <button
                    @click="cancelDownload"
                    class="btn btn-danger btn-sm">
                  <i class="bx bx-x me-1"></i>Cancel
                </button>
              </div>

              <div class="alert alert-info d-flex align-items-center" role="alert">
                <i class="bx bx-info-circle me-2"></i>
                <small>{{ downloadPaused ? 'Download is paused. Your progress has been saved.' : 'Please do not close this window or navigate away.' }}</small>
              </div>

              <div v-if="downloadProgress.totalUnitsDownloaded > 0" class="mt-3 pt-3 border-top">
                <div class="row text-center">
                  <div class="col-4">
                    <small class="text-muted d-block">Properties</small>
                    <strong>{{ downloadProgress.currentProperty }}/{{ downloadProgress.totalProperties }}</strong>
                  </div>
                  <div class="col-4">
                    <small class="text-muted d-block">Units Downloaded</small>
                    <strong>{{ numberFormat(downloadProgress.totalUnitsDownloaded) }}</strong>
                  </div>
                  <div class="col-4">
                    <small class="text-muted d-block">Success Rate</small>
                    <strong>{{ getSuccessRate() }}%</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Add Unit Category Modal -->
      <div class="modal fade add-block-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title text-uppercase" id="myLargeModalLabel">Add A category</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-12">
                  <p class="text-capitalize">
                    Enter the category Name for the category you want added
                  </p>
                  <div>
                    <label class="form-label text-uppercase">Enter Category name</label>
                    <input v-model="category" class="form-control" type="text" placeholder="Name of Category">
                  </div>

                  <div class="mt-3">
                    <table class="table align-middle table-nowrap table-hover dt-responsive contacts-table dataTable no-footer table-sm" id="">
                      <thead class="table-light">
                      <tr>
                        <th>#</th>
                        <th scope="col">Category</th>
                        <th scope="col">Number of Units</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr :key="index" :value="item" v-for="(item, index) in unitCategories">
                        <td>{{index+1}}.</td>
                        <td class="text-uppercase" @click="deleteUnitCategory(item.category)">
                          <a href="javascript: void(0);"> {{item.category}} </a>
                        </td>
                        <td>{{item.count}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <a @click="addUnitCategory()" type="button" class="btn btn-primary waves-effect waves-light">
                <i class="bx bx-check font-size-16 align-middle me-2"></i> Submit
              </a>
            </div>
          </div>
        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
          </div>
        </div>
      </footer>
    </div>
  </div>

  <div class="rightbar-overlay"></div>

  </body>
</template>

<script>
/* eslint-disable */
import {biller, execute, rent} from "@/api";
import ToolBarHousing from "@/components/housing/ToolBarHousing.vue";
import NavigationBar from "@/components/Navigation.vue";
import moment from "moment";

export default {
  components: {ToolBarHousing, NavigationBar},
  name: "HousingRegister",
  data() {
    return {
      category: '',
      loading: true,
      currentPage: 1,
      totalPages: 0,
      pageSize: 10,
      summary: {
        count: 0,
        total: 0
      },

      download: 'Download Report',
      search: '',
      totalRecords: 0,
      totalReceiptAmount: 0,
      totalUnit: 0,
      totalOccupied: 0,
      totalVaccant: 0,
      totalArreas: 0,

      properties: [],
      unitCategories: [],

      // Download functionality
      isDownloading: false,
      isDownloadingAll: false,
      downloadPaused: false,
      downloadCancelled: false,
      downloadError: null,
      downloadRetryCount: 0,
      maxRetries: 3,
      downloadProgress: {
        currentProperty: 0,
        totalProperties: 0,
        percentage: 0,
        totalUnitsDownloaded: 0,
        startTime: null,
        estimatedTimeRemaining: null,
        averageSpeed: 0,
        currentPropertyName: '',
        currentPropertyUnits: 0
      },
      allUnitsData: [],
      downloadState: {
        currentPropertyIndex: 0,
        properties: [],
        accumulatedUnits: []
      },

      // Reconciliation functionality
      isReconciling: false,
      reconcilePaused: false,
      reconcileCancelled: false,
      reconcileComplete: false,
      reconcileError: null,
      reconcileSelectedPropertyOnly: false,
      selectedPropertyForReconcile: '',
      showOnlyChanged: true,
      reconcileProgress: {
        processed: 0,
        total: 0,
        percentage: 0,
        changed: 0,
        unchanged: 0,
        errors: 0,
        startTime: null,
        estimatedTimeRemaining: null,
        speed: 0,
        currentUnit: null
      },
      reconcileResults: [],
      reconcileState: {
        currentIndex: 0,
        units: []
      }
    }
  },

  computed: {
    filteredReconcileResults() {
      if (this.showOnlyChanged) {
        return this.reconcileResults.filter(r => r.changed);
      }
      return this.reconcileResults;
    }
  },

  mounted() {
    this.getProperties();
    this.getUnitCategory();
    this.menuAccess();
  },

  watch: {
    pageSize(newPageSize) {
      this.getProperties();
      const totalItems = this.summary.count;
      const newTotalPages = Math.ceil(totalItems / newPageSize);
      this.totalPages = newTotalPages;
      this.currentPage = 1;
    },

    search: function () {
      this.getProperties();
    }
  },

  methods: {
    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Housing Register");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller)
          .then(() => {})
          .catch(() => {});
    },

    pagination(currentPage, totalPages, maxVisibleButtons) {
      let pages = [];
      let start = currentPage - Math.floor(maxVisibleButtons / 2);
      let end = currentPage + Math.floor(maxVisibleButtons / 2);

      if (start < 1) {
        start = 1;
        end = start + maxVisibleButtons - 1;
        if (end > totalPages) {
          end = totalPages;
        }
      }
      if (end > totalPages) {
        end = totalPages;
        start = end - maxVisibleButtons + 1;
        if (start < 1) {
          start = 1;
        }
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (start > 1) {
        pages.unshift("...");
      }
      if (end < totalPages) {
        pages.push("...");
      }

      return pages;
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getProperties();
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getProperties();
      }
    },

    goToPage(page) {
      if (page > 0 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
        this.getProperties();
      }
    },

    numberFormat(num) {
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(num || 0);
    },

    formatTimeRemaining(seconds) {
      if (!seconds || seconds <= 0) return 'Calculating...';

      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = Math.floor(seconds % 60);

      if (hours > 0) {
        return `${hours}h ${minutes}m ${secs}s`;
      } else if (minutes > 0) {
        return `${minutes}m ${secs}s`;
      } else {
        return `${secs}s`;
      }
    },

    getProperties() {
      this.loading = true;
      this.properties = [];
      const data = new FormData();
      data.append("function", "getProperties");
      data.append("search", this.search);
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);

      execute(data, rent)
          .then((res) => {
            this.loading = false;
            if (res.data.success) {
              this.properties = res.data.data.properties;
              this.totalReceiptAmount = res.data.data.summary.totalReceiptAmount;
              this.totalRecords = res.data.data.summary.totalRecords;

              this.totalUnit = this.properties.reduce((acc, cur) => {
                return acc + Number(cur.noOfUnits);
              }, 0);

              this.totalOccupied = this.properties.reduce((acc, cur) => {
                return acc + Number(cur.noOfOccupiedUnits);
              }, 0);

              this.totalVaccant = this.properties.reduce((acc, cur) => {
                return acc + Number(cur.noOfEmptyUnits);
              }, 0);

              this.totalArreas = this.properties.reduce((acc, cur) => {
                return acc + Number(cur.totalArrears);
              }, 0);

              this.summary.count = res.data.data.summary.totalRecords;
              this.summary.total = res.data.data.summary.totalReceiptAmount;
              this.totalPages = Math.ceil(this.summary.count / this.pageSize);
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.loading = false;
            this.message = e.message;
          });
    },

    gotTo(route, propertyID) {
      sessionStorage.setItem("propertyID", propertyID);
      this.$router.push(route);
    },

    getUnitCategory() {
      this.unitCategories = [];
      const data = new FormData();
      data.append("function", "getUnitCategory");
      execute(data, rent)
          .then((res) => {
            if (res.data.success) {
              this.unitCategories = res.data.data.unitCategories;
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    addUnitCategory() {
      if (!confirm("Are you sure you want to add this category?")) {
        return;
      }

      const data = new FormData();
      data.append("function", "addUnitCategory");
      data.append("category", this.category);
      execute(data, rent)
          .then((res) => {
            if (res.data.success) {
              this.getUnitCategory();
              this.category = '';
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    deleteUnitCategory(category) {
      if (!confirm("Are you sure you want to remove this category?")) {
        return;
      }

      const data = new FormData();
      data.append("function", "deleteUnitCategory");
      data.append("category", category);
      execute(data, rent)
          .then((res) => {
            if (res.data.success) {
              this.getUnitCategory();
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    // ==================== RECONCILIATION METHODS ====================

    showReconcileConfirmation() {
      this.reconcileSelectedPropertyOnly = false;
      this.selectedPropertyForReconcile = '';
      const modal = new bootstrap.Modal(document.getElementById('reconcileConfirmModal'));
      modal.show();
    },

    reconcileProperty(property) {
      this.reconcileSelectedPropertyOnly = true;
      this.selectedPropertyForReconcile = property.propertyID;

      const modal = new bootstrap.Modal(document.getElementById('reconcileConfirmModal'));
      modal.show();
    },

    async startReconciliation() {
      // Validate selection if specific property chosen
      if (this.reconcileSelectedPropertyOnly && !this.selectedPropertyForReconcile) {
        alert('Please select a property to reconcile');
        return;
      }

      // Close confirmation modal
      const confirmModal = bootstrap.Modal.getInstance(document.getElementById('reconcileConfirmModal'));
      if (confirmModal) confirmModal.hide();

      // Reset state
      this.isReconciling = true;
      this.reconcilePaused = false;
      this.reconcileCancelled = false;
      this.reconcileComplete = false;
      this.reconcileError = null;
      this.reconcileResults = [];
      this.reconcileProgress = {
        processed: 0,
        total: 0,
        percentage: 0,
        changed: 0,
        unchanged: 0,
        errors: 0,
        startTime: Date.now(),
        estimatedTimeRemaining: null,
        speed: 0,
        currentUnit: null
      };

      // Show progress modal
      await this.delay(300);
      const progressModal = new bootstrap.Modal(document.getElementById('reconcileProgressModal'));
      progressModal.show();

      // Fetch all units to reconcile
      const units = await this.fetchUnitsForReconciliation();

      if (units.length === 0) {
        this.reconcileError = 'No units found to reconcile';
        this.reconcileComplete = true;
        return;
      }

      this.reconcileState = {
        currentIndex: 0,
        units: units
      };

      this.reconcileProgress.total = units.length;

      // Start processing
      await this.processReconciliation();
    },

    async fetchUnitsForReconciliation() {
      const allUnits = [];

      try {
        if (this.reconcileSelectedPropertyOnly && this.selectedPropertyForReconcile) {
          // Fetch units for specific property
          const units = await this.fetchUnitsForProperty(this.selectedPropertyForReconcile);
          if (units) {
            // Add property name to each unit
            const property = this.properties.find(p => p.propertyID === this.selectedPropertyForReconcile);
            units.forEach(u => {
              u.propertyName = property ? property.property : 'Unknown';
            });
            allUnits.push(...units);
          }
        } else {
          // Fetch all units from all properties
          const allProperties = await this.fetchAllProperties();

          for (const property of allProperties) {
            const units = await this.fetchUnitsForProperty(property.propertyID);
            if (units && units.length > 0) {
              units.forEach(u => {
                u.propertyName = property.property;
              });
              allUnits.push(...units);
            }
            await this.delay(50);
          }
        }
      } catch (error) {
        console.error('Error fetching units:', error);
      }

      return allUnits;
    },

    async processReconciliation() {
      const startIndex = this.reconcileState.currentIndex;
      const units = this.reconcileState.units;

      for (let i = startIndex; i < units.length; i++) {
        // Check for pause/cancel
        if (this.reconcilePaused) {
          this.reconcileState.currentIndex = i;
          return;
        }

        if (this.reconcileCancelled) {
          return;
        }

        const unit = units[i];
        this.reconcileProgress.currentUnit = {
          unitNo: unit.unitNo,
          property: unit.propertyName || unit.property
        };

        try {
          // Call reconcile API for this unit
          const result = await this.reconcileUnit(unit);

          if (result) {
            const changed = result.oldArrears !== result.newArrears ||
                result.oldCredit !== result.newCredit;

            this.reconcileResults.push({
              unitId: unit.id,
              unitNo: unit.unitNo,
              property: unit.propertyName || unit.property,
              occupant: unit.occupants,
              oldArrears: result.oldArrears,
              newArrears: result.newArrears,
              oldCredit: result.oldCredit,
              newCredit: result.newCredit,
              totalBilled: result.totalBilled,
              totalPaid: result.totalPaid,
              changed: changed
            });

            if (changed) {
              this.reconcileProgress.changed++;
            } else {
              this.reconcileProgress.unchanged++;
            }
          }

          this.reconcileProgress.processed++;

        } catch (error) {
          console.error('Error reconciling unit:', unit.id, error);
          this.reconcileProgress.errors++;

          this.reconcileResults.push({
            unitId: unit.id,
            unitNo: unit.unitNo,
            property: unit.propertyName || unit.property,
            occupant: unit.occupants,
            oldArrears: parseFloat(unit.arrears) || 0,
            newArrears: parseFloat(unit.arrears) || 0,
            oldCredit: parseFloat(unit.creditBalance) || 0,
            newCredit: parseFloat(unit.creditBalance) || 0,
            changed: false,
            error: error.message
          });
        }

        // Update progress
        this.reconcileProgress.percentage = Math.round(((i + 1) / units.length) * 100);
        this.calculateReconcileTimeRemaining();

        // Small delay to prevent server overload
        await this.delay(100);
      }

      // Complete
      this.reconcileComplete = true;
      this.isReconciling = false;

      // Refresh properties data
      this.getProperties();
    },

    async reconcileUnit(unit) {
      return new Promise((resolve, reject) => {
        const data = new FormData();
        data.append("function", "reconcileUnit");
        data.append("unitId", unit.id);
        data.append("sessionNames", sessionStorage.getItem("sessionNames"));
        data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

        // Store old values before API call
        const oldArrears = parseFloat(unit.arrears) || 0;
        const oldCredit = parseFloat(unit.creditBalance) || 0;

        execute(data, rent)
            .then((res) => {
              if (res.data.success) {
                resolve({
                  oldArrears: oldArrears,
                  newArrears: res.data.data.newArrears || 0,
                  oldCredit: oldCredit,
                  newCredit: res.data.data.newCredit || 0,
                  totalBilled: res.data.data.unpaidBilled || res.data.data.totalBilled || 0,
                  totalPaid: res.data.data.totalPaid || 0
                });
              } else {
                reject(new Error(res.data.message || 'Reconciliation failed'));
              }
            })
            .catch((error) => {
              reject(error);
            });
      });
    },

    calculateReconcileTimeRemaining() {
      if (!this.reconcileProgress.startTime || this.reconcileProgress.processed === 0) {
        return;
      }

      const elapsedTime = (Date.now() - this.reconcileProgress.startTime) / 1000;
      const processed = this.reconcileProgress.processed;
      const remaining = this.reconcileProgress.total - processed;

      if (processed > 0 && elapsedTime > 0) {
        const speed = processed / elapsedTime;
        this.reconcileProgress.speed = speed.toFixed(1);
        this.reconcileProgress.estimatedTimeRemaining = remaining / speed;
      }
    },

    pauseReconciliation() {
      this.reconcilePaused = true;
    },

    async resumeReconciliation() {
      this.reconcilePaused = false;
      await this.processReconciliation();
    },

    cancelReconciliation() {
      if (confirm('Are you sure you want to cancel? Progress will be lost.')) {
        this.reconcileCancelled = true;
        this.closeReconcileModal();
      }
    },

    closeReconcileModal() {
      const modalElement = document.getElementById('reconcileProgressModal');
      if (modalElement) {
        const existingModal = bootstrap.Modal.getInstance(modalElement);
        if (existingModal) {
          existingModal.hide();
        }
      }

      // Clean up
      document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';

      // Reset state
      this.isReconciling = false;
      this.reconcilePaused = false;
      this.reconcileCancelled = false;
    },

    downloadReconcileReport() {
      if (this.reconcileResults.length === 0) {
        alert('No results to download');
        return;
      }

      // Generate CSV
      const headers = [
        'NO.',
        'Unit No',
        'Property',
        'Occupant',
        'Old Arrears',
        'New Arrears',
        'Arrears Change',
        'Old Credit',
        'New Credit',
        'Credit Change',
        'Total Billed',
        'Total Paid',
        'Status'
      ];

      let csv = headers.join(',') + '\n';

      this.reconcileResults.forEach((result, index) => {
        const arrearsChange = result.newArrears - result.oldArrears;
        const creditChange = result.newCredit - result.oldCredit;

        const row = [
          index + 1,
          this.escapeCSV(result.unitNo),
          this.escapeCSV(result.property),
          this.escapeCSV(result.occupant || ''),
          result.oldArrears,
          result.newArrears,
          arrearsChange,
          result.oldCredit,
          result.newCredit,
          creditChange,
          result.totalBilled || 0,
          result.totalPaid || 0,
          result.changed ? 'CHANGED' : 'NO CHANGE'
        ];
        csv += row.join(',') + '\n';
      });

      // Add summary
      csv += '\n';
      csv += 'RECONCILIATION SUMMARY\n';
      csv += `Date,${moment().format('DD/MM/YYYY HH:mm:ss')}\n`;
      csv += `Total Units Processed,${this.reconcileProgress.processed}\n`;
      csv += `Units Changed,${this.reconcileProgress.changed}\n`;
      csv += `Units Unchanged,${this.reconcileProgress.unchanged}\n`;
      csv += `Errors,${this.reconcileProgress.errors}\n`;
      csv += '\n';

      // Calculate totals
      const totalOldArrears = this.reconcileResults.reduce((sum, r) => sum + r.oldArrears, 0);
      const totalNewArrears = this.reconcileResults.reduce((sum, r) => sum + r.newArrears, 0);
      const totalOldCredit = this.reconcileResults.reduce((sum, r) => sum + r.oldCredit, 0);
      const totalNewCredit = this.reconcileResults.reduce((sum, r) => sum + r.newCredit, 0);

      csv += 'FINANCIAL SUMMARY\n';
      csv += `Total Old Arrears,${totalOldArrears}\n`;
      csv += `Total New Arrears,${totalNewArrears}\n`;
      csv += `Arrears Difference,${totalNewArrears - totalOldArrears}\n`;
      csv += `Total Old Credit,${totalOldCredit}\n`;
      csv += `Total New Credit,${totalNewCredit}\n`;
      csv += `Credit Difference,${totalNewCredit - totalOldCredit}\n`;

      // Download
      const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);

      link.setAttribute('href', url);
      link.setAttribute('download', `Reconciliation_Report_${moment().format('YYYY-MM-DD_HHmmss')}.csv`);
      link.style.visibility = 'hidden';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    // ==================== DOWNLOAD METHODS (existing) ====================

    calculateEstimatedTime() {
      if (!this.downloadProgress.startTime || this.downloadProgress.currentProperty === 0) {
        return;
      }

      const elapsedTime = (Date.now() - this.downloadProgress.startTime) / 1000;
      const propertiesDownloaded = this.downloadProgress.currentProperty;
      const remainingProperties = this.downloadProgress.totalProperties - propertiesDownloaded;

      if (propertiesDownloaded > 0 && elapsedTime > 0) {
        const averageSpeed = propertiesDownloaded / elapsedTime;
        this.downloadProgress.averageSpeed = averageSpeed.toFixed(2);

        const estimatedTimeRemaining = remainingProperties / averageSpeed;
        this.downloadProgress.estimatedTimeRemaining = estimatedTimeRemaining;
      }
    },

    getSuccessRate() {
      if (this.downloadProgress.totalProperties === 0) return 100;
      const successfulProperties = this.downloadProgress.currentProperty - this.downloadRetryCount;
      return Math.round((successfulProperties / this.downloadProgress.totalProperties) * 100);
    },

    async downloadCurrentPage() {
      if (this.properties.length === 0) {
        alert('No data available to download');
        return;
      }

      this.isDownloading = true;

      try {
        const allUnits = [];

        for (const property of this.properties) {
          const units = await this.fetchUnitsForProperty(property.propertyID);
          if (units && units.length > 0) {
            allUnits.push(...units);
          }
        }

        if (allUnits.length === 0) {
          alert('No units found for the properties on this page');
          this.isDownloading = false;
          return;
        }

        const csv = this.generateCSV(allUnits);

        const blob = new Blob(['\ufeff' + csv], {type: 'text/csv;charset=utf-8;'});
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        link.setAttribute('href', url);
        link.setAttribute('download', `Housing_Units_Page_${this.currentPage}_${moment().format('YYYY-MM-DD_HHmmss')}.csv`);
        link.style.visibility = 'hidden';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        alert(`Successfully downloaded ${allUnits.length} units from ${this.properties.length} properties`);
      } catch (error) {
        console.error('Download error:', error);
        alert('Failed to download data: ' + error.message);
      } finally {
        this.isDownloading = false;
      }
    },

    async downloadAllRecords() {
      if (this.totalUnit === 0) {
        alert('No units to download');
        return;
      }

      const isConfirmed = confirm(
          `You are about to download all ${this.numberFormat(this.totalUnit)} housing units from ${this.numberFormat(this.properties.length)} properties. This may take several minutes. Do you want to continue?`
      );

      if (!isConfirmed) return;

      this.isDownloadingAll = true;
      this.downloadPaused = false;
      this.downloadCancelled = false;
      this.downloadError = null;
      this.downloadRetryCount = 0;
      this.allUnitsData = [];

      const allProperties = await this.fetchAllProperties();

      this.downloadState = {
        currentPropertyIndex: 0,
        properties: allProperties,
        accumulatedUnits: []
      };

      this.downloadProgress = {
        currentProperty: 0,
        totalProperties: allProperties.length,
        percentage: 0,
        totalUnitsDownloaded: 0,
        startTime: Date.now(),
        estimatedTimeRemaining: null,
        averageSpeed: 0,
        currentPropertyName: '',
        currentPropertyUnits: 0
      };

      const modalElement = document.getElementById('downloadProgressModal');
      const progressModal = new bootstrap.Modal(modalElement);
      progressModal.show();

      await this.continueDownload();
    },

    async fetchAllProperties() {
      const allProperties = [];
      let page = 1;
      let hasMore = true;

      while (hasMore) {
        try {
          const data = new FormData();
          data.append("function", "getProperties");
          data.append("search", this.search || '');
          data.append("page", page);
          data.append("rows_per_page", 100);

          const res = await execute(data, rent);

          if (res.data.success && res.data.data.properties.length > 0) {
            allProperties.push(...res.data.data.properties);
            page++;

            if (res.data.data.pagination && res.data.data.pagination.current_page >= res.data.data.pagination.total_pages) {
              hasMore = false;
            }
          } else {
            hasMore = false;
          }

          await this.delay(50);
        } catch (error) {
          console.error('Error fetching properties:', error);
          hasMore = false;
        }
      }

      return allProperties;
    },

    async fetchUnitsForProperty(propertyID) {
      try {
        const data = new FormData();
        data.append("function", "getUnits");
        data.append("propertyID", propertyID);
        data.append("page", 1);
        data.append("rows_per_page", 10000);

        const res = await execute(data, rent);

        if (res.data.success && res.data.data.units) {
          return res.data.data.units;
        }
        return [];
      } catch (error) {
        console.error('Error fetching units for property:', propertyID, error);
        return [];
      }
    },

    async continueDownload() {
      try {
        const startIndex = this.downloadState.currentPropertyIndex;
        const totalProperties = this.downloadState.properties.length;

        for (let i = startIndex; i < totalProperties; i++) {
          if (this.downloadPaused) {
            console.log('Download paused, waiting for resume...');
            return;
          }

          if (this.downloadCancelled) {
            console.log('Download cancelled by user');
            return;
          }

          const property = this.downloadState.properties[i];

          try {
            this.downloadState.currentPropertyIndex = i;
            this.downloadProgress.currentProperty = i + 1;
            this.downloadProgress.currentPropertyName = property.property || 'Unknown Property';
            this.downloadProgress.percentage = Math.round(((i + 1) / totalProperties) * 100);

            const units = await this.fetchUnitsForPropertyWithRetry(property.propertyID);

            if (units && units.length > 0) {
              this.downloadState.accumulatedUnits.push(...units);
              this.allUnitsData = this.downloadState.accumulatedUnits;
              this.downloadProgress.totalUnitsDownloaded = this.allUnitsData.length;
              this.downloadProgress.currentPropertyUnits = units.length;

              this.calculateEstimatedTime();
            }

            this.downloadRetryCount = 0;
            this.downloadError = null;

            await this.delay(100);

          } catch (error) {
            console.error(`Error processing property ${property.property}:`, error);
            this.downloadError = error.message;
            this.downloadPaused = true;
            return;
          }
        }

        await this.finalizeDownload();

      } catch (error) {
        console.error('Download error:', error);
        this.downloadError = error.message;
        this.downloadPaused = true;
      }
    },

    async fetchUnitsForPropertyWithRetry(propertyID, retryCount = 0) {
      try {
        return await this.fetchUnitsForProperty(propertyID);
      } catch (error) {
        if (retryCount < this.maxRetries) {
          this.downloadRetryCount = retryCount + 1;
          await this.delay(1000 * (retryCount + 1));
          return await this.fetchUnitsForPropertyWithRetry(propertyID, retryCount + 1);
        } else {
          throw error;
        }
      }
    },

    async finalizeDownload() {
      try {
        if (this.allUnitsData.length === 0) {
          alert('No units data to download');
          this.closeDownloadModal();
          return;
        }

        const csv = this.generateCSV(this.allUnitsData);

        const blob = new Blob(['\ufeff' + csv], {type: 'text/csv;charset=utf-8;'});
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        link.setAttribute('href', url);
        link.setAttribute('download', `All_Housing_Units_${moment().format('YYYY-MM-DD_HHmmss')}.csv`);
        link.style.visibility = 'hidden';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        alert(`Successfully downloaded ${this.numberFormat(this.allUnitsData.length)} units from ${this.downloadProgress.totalProperties} properties`);

        this.closeDownloadModal();

      } catch (error) {
        console.error('Finalize download error:', error);
        alert('Error finalizing download: ' + error.message);
        this.closeDownloadModal();
      }
    },

    generateCSV(units) {
      if (!units || units.length === 0) return '';

      const headers = [
        'NO.',
        'Property Name',
        'Unit Number',
        'Category',
        'Occupant Name',
        'Phone Number',
        'ID Number',
        'Status',
        'Monthly Rent',
        'Arrears',
        'Credit Balance',
        'Current Balance',
        'Sub County',
        'Ward',
        'Zone',
        'Last Payment Date',
        'Last Billing Date',
        'Effective Date',
        'Updated By',
        'Date Updated'
      ];

      let csv = headers.join(',') + '\n';

      units.forEach((unit, index) => {
        const row = [
          index + 1,
          this.escapeCSV(unit.property || ''),
          this.escapeCSV(unit.unitNo || ''),
          this.escapeCSV(unit.category || ''),
          this.escapeCSV(unit.occupants || ''),
          this.escapeCSV(unit.phoneNumber || ''),
          this.escapeCSV(unit.idNo || ''),
          this.escapeCSV(unit.status || ''),
          unit.monthlyRent || 0,
          unit.arrears || 0,
          unit.creditBalance || 0,
          unit.current_balance || 0,
          this.escapeCSV(unit.subCountyName || ''),
          this.escapeCSV(unit.wardName || ''),
          this.escapeCSV(unit.zone || ''),
          this.formatDateForExport(unit.lastPaymentDate),
          this.formatDateForExport(unit.last_billing_date),
          this.formatDateForExport(unit.effectiveDate),
          this.escapeCSV(unit.updatedBy || ''),
          this.formatDateForExport(unit.updated)
        ];
        csv += row.join(',') + '\n';
      });

      csv += '\n';
      csv += `SUMMARY\n`;
      csv += `Total Units,${units.length}\n`;
      csv += `Total Monthly Rent,${units.reduce((sum, u) => sum + parseFloat(u.monthlyRent || 0), 0)}\n`;
      csv += `Total Arrears,${units.reduce((sum, u) => sum + parseFloat(u.arrears || 0), 0)}\n`;
      csv += `Occupied Units,${units.filter(u => u.status === 'OCCUPIED').length}\n`;
      csv += `Vacant Units,${units.filter(u => u.status === 'EMPTY' || u.status === 'VACANT').length}\n`;

      return csv;
    },

    escapeCSV(value) {
      if (value === null || value === undefined) return '';
      const stringValue = String(value);
      if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
        return '"' + stringValue.replace(/"/g, '""') + '"';
      }
      return stringValue;
    },

    formatDateForExport(dateString) {
      if (!dateString) return '';
      return moment(dateString).format('DD/MM/YYYY HH:mm:ss');
    },

    pauseDownload() {
      this.downloadPaused = true;
      console.log('Download paused at property:', this.downloadState.currentPropertyIndex);
    },

    async resumeDownload() {
      this.downloadPaused = false;
      this.downloadError = null;
      this.downloadRetryCount = 0;

      console.log('Resuming download from property:', this.downloadState.currentPropertyIndex + 1);

      await this.continueDownload();
    },

    cancelDownload() {
      const confirmed = confirm('Are you sure you want to cancel the download? All progress will be lost.');

      if (confirmed) {
        this.downloadCancelled = true;
        this.closeDownloadModal();
      }
    },

    closeDownloadModal() {
      const modalElement = document.getElementById('downloadProgressModal');
      if (modalElement) {
        const existingModal = bootstrap.Modal.getInstance(modalElement);
        if (existingModal) {
          existingModal.hide();
        }
      }

      document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';

      this.isDownloadingAll = false;
      this.downloadPaused = false;
      this.downloadCancelled = false;
      this.downloadError = null;
      this.downloadRetryCount = 0;
      this.allUnitsData = [];
      this.downloadProgress = {
        currentProperty: 0,
        totalProperties: 0,
        percentage: 0,
        totalUnitsDownloaded: 0,
        startTime: null,
        estimatedTimeRemaining: null,
        averageSpeed: 0,
        currentPropertyName: '',
        currentPropertyUnits: 0
      };
      this.downloadState = {
        currentPropertyIndex: 0,
        properties: [],
        accumulatedUnits: []
      };
    },

    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }
  }
}
</script>

<style scoped>
.btn-group {
  display: flex;
  gap: 0.5rem;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.15em;
}

.progress {
  height: 25px;
}

.modal-content {
  border-radius: 0.5rem;
}

.alert {
  border-radius: 0.375rem;
}

.gap-2 {
  gap: 0.5rem;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1;
}

.bx-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>